// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cyoOEsKbCzRmEzzMLXNU {
    background-color: var(--color-primary-white);
    border-radius: 12px;
    margin: 0 auto;
    text-align: center;
    width: 100%;
    max-width: 28rem;
    padding: 1rem 1.5rem;
    box-sizing: border-box;
    padding-bottom: 0.75rem;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
    border: 1px solid transparent;
}

.cyoOEsKbCzRmEzzMLXNU p,
.cyoOEsKbCzRmEzzMLXNU .szuC_vurhVcFAYR2yihl {
    color: var(--color-primary-black) !important;
    -webkit-text-fill-color: var(--color-primary-black) !important;
}

.nIPysfqVuOTVvspUphNK {
    color: var(--color-primary-black) !important;
    text-decoration: underline !important;
    display: inline-block;
    min-height: 24px;
    line-height: 24px;
    padding: 4px 6px;
}

.nIPysfqVuOTVvspUphNK:hover {
    color: #d32f2f !important;
    text-decoration: underline !important;
}

.cyoOEsKbCzRmEzzMLXNU a,
.cyoOEsKbCzRmEzzMLXNU .nIPysfqVuOTVvspUphNK {
    -webkit-text-fill-color: initial !important;
    color: var(--color-primary-black) !important;
    text-decoration: underline !important;
}

.cyoOEsKbCzRmEzzMLXNU a:hover,
.cyoOEsKbCzRmEzzMLXNU .nIPysfqVuOTVvspUphNK:hover {
    color: #d32f2f !important;
    -webkit-text-fill-color: initial !important;
}

.ZPSBWVEAhgEWCSUubIfE {
    margin-bottom: 0.75rem;
}

.cyoOEsKbCzRmEzzMLXNU.Ss_wxWkddkZc1rbOcqvj,
.cyoOEsKbCzRmEzzMLXNU.NpkLbzoqOi5Fcr191AwE {
    box-shadow: none;
    border: 1px solid #dddddd;
}

.KIzFhDwiaydepuoj5PPZ {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

@media (width <= 600px) {
    .KIzFhDwiaydepuoj5PPZ {
        white-space: nowrap;
        justify-content: flex-start !important;
    }
}

button[data-testid="deviceLinkBtn"] {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.Dx9pJUndIAsfS79UpBZg {
    width: 1.2em;
    height: 1.2em;
    flex-shrink: 0;
    margin-top: 0.1em;
    gap: 0.5rem;
}

.OdWTdXwQZTzmWIf53NT2 {
    width: 1.6em;
    height: 1.6em;
    flex-shrink: 0;
    margin-right: 0.5rem;
    margin-left: 0;
    display: inline-block;
    color: white;
}

.m0rjPM_XeR4iyKjb5Nad {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
}

@media (max-width: 768px) {
    .cyoOEsKbCzRmEzzMLXNU > .szuC_vurhVcFAYR2yihl:first-of-type {
        margin-bottom: 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/DeviceLinkBox/DeviceLinkBox.module.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,wDAAwD;IACxD,6BAA6B;AACjC;;AAEA;;IAEI,4CAA4C;IAC5C,8DAA8D;AAClE;;AAEA;IACI,4CAA4C;IAC5C,qCAAqC;IACrC,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;;IAEI,2CAA2C;IAC3C,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA;;IAEI,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI;QACI,mBAAmB;QACnB,sCAAsC;IAC1C;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".device-link-box {\n    background-color: var(--color-primary-white);\n    border-radius: 12px;\n    margin: 0 auto;\n    text-align: center;\n    width: 100%;\n    max-width: 28rem;\n    padding: 1rem 1.5rem;\n    box-sizing: border-box;\n    padding-bottom: 0.75rem;\n    transition: box-shadow 0.2s ease, border-color 0.2s ease;\n    border: 1px solid transparent;\n}\n\n.device-link-box p,\n.device-link-box .MuiTypography-root {\n    color: var(--color-primary-black) !important;\n    -webkit-text-fill-color: var(--color-primary-black) !important;\n}\n\n.learn-more-link {\n    color: var(--color-primary-black) !important;\n    text-decoration: underline !important;\n    display: inline-block;\n    min-height: 24px;\n    line-height: 24px;\n    padding: 4px 6px;\n}\n\n.learn-more-link:hover {\n    color: #d32f2f !important;\n    text-decoration: underline !important;\n}\n\n.device-link-box a,\n.device-link-box .learn-more-link {\n    -webkit-text-fill-color: initial !important;\n    color: var(--color-primary-black) !important;\n    text-decoration: underline !important;\n}\n\n.device-link-box a:hover,\n.device-link-box .learn-more-link:hover {\n    color: #d32f2f !important;\n    -webkit-text-fill-color: initial !important;\n}\n\n.learn-more-wrapper {\n    margin-bottom: 0.75rem;\n}\n\n.device-link-box.active,\n.device-link-box.inactive {\n    box-shadow: none;\n    border: 1px solid #dddddd;\n}\n\n.button-content {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n@media (width <= 600px) {\n    .button-content {\n        white-space: nowrap;\n        justify-content: flex-start !important;\n    }\n}\n\nbutton[data-testid=\"deviceLinkBtn\"] {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n.qr-button-icon {\n    width: 1.2em;\n    height: 1.2em;\n    flex-shrink: 0;\n    margin-top: 0.1em;\n    gap: 0.5rem;\n}\n\n.smart-id-button-icon {\n    width: 1.6em;\n    height: 1.6em;\n    flex-shrink: 0;\n    margin-right: 0.5rem;\n    margin-left: 0;\n    display: inline-block;\n    color: white;\n}\n\n.sr-only {\n    position: absolute !important;\n    width: 1px !important;\n    height: 1px !important;\n    padding: 0 !important;\n    margin: -1px !important;\n    overflow: hidden !important;\n    clip: rect(0, 0, 0, 0) !important;\n    white-space: nowrap !important;\n    border: 0 !important;\n}\n\n@media (max-width: 768px) {\n    .device-link-box > .MuiTypography-root:first-of-type {\n        margin-bottom: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deviceLinkBox": `cyoOEsKbCzRmEzzMLXNU`,
	"muiTypographyRoot": `szuC_vurhVcFAYR2yihl`,
	"learnMoreLink": `nIPysfqVuOTVvspUphNK`,
	"learnMoreWrapper": `ZPSBWVEAhgEWCSUubIfE`,
	"active": `Ss_wxWkddkZc1rbOcqvj`,
	"inactive": `NpkLbzoqOi5Fcr191AwE`,
	"buttonContent": `KIzFhDwiaydepuoj5PPZ`,
	"qrButtonIcon": `Dx9pJUndIAsfS79UpBZg`,
	"smartIdButtonIcon": `OdWTdXwQZTzmWIf53NT2`,
	"srOnly": `m0rjPM_XeR4iyKjb5Nad`
};
module.exports = ___CSS_LOADER_EXPORT___;
